import config from './config';

// Consentement aux cookies, conforme aux recommandations de la CNIL :
// - aucun script Google n'est chargé avant l'accord du visiteur ;
// - le choix (accord ou refus) est conservé 6 mois, puis redemandé ;
// - il peut être modifié à tout moment via « Gérer mes cookies ».

const STORAGE_KEY = 'altes-consent';
const CONSENT_DURATION_MS = 1000 * 60 * 60 * 24 * 182;
const OPEN_EVENT = 'altes:open-cookie-settings';

export const readConsent = () => {
  try {
    const stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
    if (!stored || Date.now() - stored.date > CONSENT_DURATION_MS) return null;
    return stored;
  } catch {
    return null;
  }
};

let googleLoaded = false;

const loadGoogleTag = () => {
  const ids = [config.ga4Id, config.adsId].filter(Boolean);
  if (googleLoaded || ids.length === 0) return;
  googleLoaded = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('consent', 'default', {
    ad_storage: 'granted',
    analytics_storage: 'granted',
    ad_user_data: 'granted',
    ad_personalization: 'granted'
  });
  window.gtag('js', new Date());
  ids.forEach((id) => window.gtag('config', id));

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${ids[0]}`;
  document.head.appendChild(script);
};

export const saveConsent = (accepted) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted, date: Date.now() }));
  } catch {
    // Navigation privée ou stockage bloqué : le choix vaut pour cette visite seulement.
  }
  if (accepted) {
    loadGoogleTag();
  } else if (googleLoaded) {
    // Retrait du consentement : on recharge la page pour décharger les scripts Google.
    window.location.reload();
  }
};

// Au chargement : si le visiteur a déjà accepté, on active Google sans redemander.
export const applyStoredConsent = () => {
  if (readConsent()?.accepted) loadGoogleTag();
};

export const hasAnalyticsConsent = () => Boolean(readConsent()?.accepted) && googleLoaded;

export const openCookieSettings = () => window.dispatchEvent(new Event(OPEN_EVENT));

export const onOpenCookieSettings = (handler) => {
  window.addEventListener(OPEN_EVENT, handler);
  return () => window.removeEventListener(OPEN_EVENT, handler);
};
